declare global {
  const CONFIG: any;
}

interface Config {
  ALGOLIA_APPLICATION_ID: string;
  ALGOLIA_INDEX_PREFIX: string;
  ALGOLIA_READ_ONLY_API_KEY: string;
  AUTH0_AUDIENCE: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_DOMAIN: string;
  AUTH0_REDIRECT_URI: string;
  GOOGLE_ANALYTICS_ID: string;
  GOOGLE_ANALYTICS_GA4_ID: string;
  GOOGLE_API_KEY: string;
  INTERCOM_APP_ID: string;
  LINKSF_DOMAIN: string;
  MOHCD_DOMAIN: string;
  MOHCD_SUBDOMAIN: string;
  SENTRY_PROJECT_ID: string;
  SENTRY_PUBLIC_KEY: string;
  SFFAMILIES_DOMAIN: string;
  SFFAMILIES_USERWAY_APP_ID: string;
  UCSF_DOMAIN: string;
}

const config: Config = {
  ALGOLIA_APPLICATION_ID: CONFIG.ALGOLIA_APPLICATION_ID,
  ALGOLIA_INDEX_PREFIX: CONFIG.ALGOLIA_INDEX_PREFIX,
  ALGOLIA_READ_ONLY_API_KEY: CONFIG.ALGOLIA_READ_ONLY_API_KEY,
  AUTH0_AUDIENCE: CONFIG.AUTH0_AUDIENCE,
  AUTH0_CLIENT_ID: CONFIG.AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: CONFIG.AUTH0_DOMAIN,
  AUTH0_REDIRECT_URI: CONFIG.AUTH0_REDIRECT_URI,
  // When GA sunsets Universal Analytics wit GA4 in July 2023, this prop can be removed
  GOOGLE_ANALYTICS_ID:
    process.env.NODE_ENV === "production" ? "UA-116318550-1" : "UA-116318550-2",
  GOOGLE_ANALYTICS_GA4_ID:
    process.env.NODE_ENV === "production" ? "G-91R319RLN0" : "G-NSEENP26HN",
  GOOGLE_API_KEY: CONFIG.GOOGLE_API_KEY,
  INTERCOM_APP_ID: "w50oz3tb",
  LINKSF_DOMAIN: CONFIG.LINKSF_DOMAIN,
  MOHCD_DOMAIN: CONFIG.MOHCD_DOMAIN,
  MOHCD_SUBDOMAIN: CONFIG.MOHCD_SUBDOMAIN,
  SENTRY_PROJECT_ID: "1291512",
  SENTRY_PUBLIC_KEY: "64ab4b168902441a9e8069bab36849be",
  SFFAMILIES_DOMAIN: CONFIG.SFFAMILIES_DOMAIN,
  SFFAMILIES_USERWAY_APP_ID: "4EhNmEIwPz",
  UCSF_DOMAIN: "dcnav",
};

if (CONFIG.TESTCAFE_RUNNING) {
  delete (config as any).INTERCOM_APP_ID;
}

export default config;
